import React from 'react';

export const LinkCellRenderer = () => {
    const env = import.meta.env.VITE_ENV;

    const Renderer = ({ data }) => {
        if (data && data.catalogId !== null && data.sourceRightslineId > 0) {
            let url = '';
            if (env === 'local' || env === 'development') {
                url = `https://app-int.rightsline.com/Asset/Rights/${data.catalogId}`;
            } else if (env === 'staging') {
                url = `https://app-staging.rightsline.com/mod1/${data.catalogId}/rights`;
            } else if (env === 'production') {
                url = `https://app.rightsline.com/mod1/${data.catalogId}/rights`;
            }

            return (
                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#3611c8' }}
                >
                    {data.catalogId}
                </a>
            );
        } else {
            return null;
        }
    };

    return Renderer;
};
